module.exports = __webpack_public_path__ + "static/img/pic_szh_zhptyy_ny_lb1@2x.ebd41ad1.png";